export default __webpack_public_path__ + "static/media/sass.540ec25f.svg";